export default (open, title, {event='open::my-album-modal', ...options}) => {
    const ALL_IMAGES = 0;
    const FAVORITE_IMAGES = 2;
    const READY_TO_DOWNLOAD = 1;
    const PROCESSING_IMAGES = 3;

    return {
        open,
        event,
        title,
        tab: 0,
        key: null,
        height: '',
        quantity: 1,
        eventId: null,
        prefetch: {},
        imagesCount: 0,
        favoriteCount: 0,
        imagesSendedCount: 0,
        downloading: [],
        myAlbumImages: [],
        currentIndex: null,
        selectedImages: {},
        stillProcessingImages: false,
        showHeaderActions: !(window.innerWidth < 640),

        init() {
            window.addEventListener(event, ({detail}) => this.set(detail));
            window.addEventListener(`${event}::update::selected`, ({detail}) => this.selectImages(detail));
            window.addEventListener(`close-my-album-modal`, () => this.open = false);

            window.addEventListener(`${event}::update`, () => this.refreshVirtualScroll())

            this.$watch('open', (open) => {
                this.$removeScroll(!open);

                this.$dispatch('refresh-status-filter');
                this.$dispatch('refresh-event-filter', {});

                if(open) {
                    this.imagesCount = 0;

                    if(/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                        this.$el.querySelector('.images-modal')?.classList.add('ios')
                    }
                }
            });
        },

        set({images, selected = {}, key = null, quantity = 1, currentIndex = null, tab=null}, open = true, image) {
            if (this.eventId) {
                this.$dispatch('clear-event-filter');
            }

            this.open           = open;
            this.key            = key;
            this.quantity       = quantity;
            this.currentIndex   = currentIndex;
            this.selectedImages = {...selected};

            this.tab = tab ?? this.imagesSendedCount ? READY_TO_DOWNLOAD : ALL_IMAGES;
            this.height = this.getHeight();

            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.refreshVirtualScroll();
        },

        getHeight() {
            if(window.innerWidth <= 640){
                let pixel = 240;

                if(this.imagesSendedCount > 0){
                    pixel = pixel + 90;
                }

                if(this.stillProcessingImages ?? null){
                    pixel = pixel + 45;
                }

                return  `calc(max - ${pixel}px)`;
            }

            return  'calc(max - 180px)';
        },

        checkHasImagesPreparingToDownload(allImages) {
            return Object.values(allImages).map(
                (images) => images.filter(
                    (image) => image.paid === 1 && image.print_only === 0 && image.sent_at == null
                )
            ).filter(element => element.length).length > 0;
        },

        filterImagesByEvent(eventId = null) {
            this.eventId = eventId;
        },

        selectTab(tab = null) {
            switch (tab) {
                case ALL_IMAGES:
                    return this.allTab();
                case READY_TO_DOWNLOAD:
                    return this.readyToDownload();
                case FAVORITE_IMAGES:
                    return this.favoriteTab();
                default:
                    return this.processingTab();
            }
        },

        allTab() {
            this.tab = ALL_IMAGES;
            this.refreshVirtualScroll();
        },

        readyToDownload() {
            this.tab = READY_TO_DOWNLOAD;
            this.refreshVirtualScroll();
        },

        favoriteTab() {
            this.tab = FAVORITE_IMAGES;
            this.refreshVirtualScroll();
        },

        processingTab() {
            this.tab = PROCESSING_IMAGES;
            this.refreshVirtualScroll();
        },

        share() {
            this.$wire.share(this.key);
        },

        openSliderPreview(event) {
            const imageId = _.get(event, 'detail.id');

            this.$dispatch('open::slider-preview', [
                this.myAlbumImages,
                _.findIndex(this.myAlbumImages, {id: imageId}),
                {
                    canDownload: _.get(options, 'canDownload', false),
                    canFavorite: _.get(options, 'canFavorite', false),
                    canSelect: _.get(options, 'canSelect', false),
                    imageAttr: _.get(options, 'imageAttr', 'preview'),
                    watermark: _.get(options, 'watermark'),
                    event: `${this.event}::toggle`,
                    selected: this.selectedImages,
                    quantity: this.quantity,
                    route: _.get(options, 'route', 'customer'),
                    totalImagesCount: this.imagesCount,
                }
            ]);
        },

        async download(event){
            const image = _.get(event, 'detail');
            const name = _.get(image, 'name');

            if (this.$isMobileSafari()) {
                this.$dispatch('view-photo-modal::open', image);

                this.downloading = this.downloading.filter(
                    (downloaded) => downloaded !== name
                );

                this.$dispatch(this.event, { image });

                return;
            }

            this.downloading.push(name);

            this.$downloadImage(_.get(image, 'high_res'), name, () => {
                this.downloading = this.downloading.filter(
                    (downloaded) => downloaded !== name
                );

                this.refreshVirtualScroll(image);
            });
        },

        selectImages(images) {
            this.selectedImages = images;
            this.refreshVirtualScroll();
        },

        saved(image) {
            return image.saved;
        },

        favorited(image) {
            return image.favorite;
        },

        save(event) {
            const image = _.get(event, 'detail', {})

            if(image.favorite) {
                this.favoriteCount -= 1;
            }

            this.$store.customerImages.toggleImage(image);
            this.imagesCount += image.saved ? 1 : -1;
            this.refreshEventsFilter();
        },

        async favorite(event) {
            const image = _.get(event, 'detail', {})

            if(!image.saved && !image.favorite) {
                this.imagesCount += 1;
            }

            this.$store.customerImages.toggleFavoriteImage(image);
            this.favoriteCount += image.favorite ? 1 : -1;
            this.refreshEventsFilter();
        },

        isSelected(imageId) {
            return Object.keys(this.selectedImages)
                .findIndex((id) => String(id) == String(imageId)) > -1;
        },

        handleCheck(event) {
            const image = _.get(event, 'detail.data', {});

            if(this.isSelected(image.id)) {
                delete this.selectedImages[image.id];
                return;
            }

            if( !this.canSelect() ) {
                return;
            }

            if (this.$store.packageData.exceptRequirement(this.currentIndex).hasImage(image.id)) {
                window.$wireui.dialog({
                    title: 'DUPLICATE PHOTO WARNING',
                    description: `You're trying to add an image you've already selected for other image slots.`,
                    icon: "warning",
                    closeButton: false,
                    close: 'OK, I Understand',
                });
            }

            this.selectedImages[image.id] = image;
        },

        getLabel({event_name, event_date}) {
            return `${event_date}# ${event_name}`;
        },

        update() {
            this.$dispatch(`${event}::update`);
        },

        refreshVirtualScroll(image = null) {
            let params = {
                eventId: this.eventId,
                mainEventId: Alpine.store('cart').mainEvent.id,
                ready: this.tab == READY_TO_DOWNLOAD ? 1 : null,
                favorite: this.tab == FAVORITE_IMAGES ? 1 : null,
                processing: this.tab == PROCESSING_IMAGES ? 1 : null,
            };

            if(image) {
                params.image = image;
                this.$dispatch(`${event}::refresh`, { params });

                return;
            }

            this.$dispatch(`${event}::restart`, { params });
            this.refreshEventsFilter();
        },

        mobileOptions() {
            const options = [
                { label: 'View All', value: ALL_IMAGES },
                { label: 'View Just Favorites', value: FAVORITE_IMAGES },
            ];

            if (this.stillProcessingImages) {
                options.push({ label: 'Processing', value: PROCESSING_IMAGES });
            }

            if (this.imagesSendedCount) {
                options.push({ label: 'Ready To Download', value: READY_TO_DOWNLOAD });
            }

            return options;
        },

        loadedImages($data) {
            this.myAlbumImages = $data.items;
            this.prefetch = $data.prefetchResponse;

            if(!this.imagesCount && $data.totalRowsCount) {
                this.refreshEventsFilter();
            }

            this.imagesCount   = $data.totalRowsCount;
            this.favoriteCount = $data.favoriteRows;
            this.imagesSendedCount = this.prefetch.sended_count;

            this.stillProcessingImages = $data.prefetch.processing_count > 0;
        },

        refreshEventsFilter() {
            this.$dispatch('refresh-event-filter', {
                with_saved_image: true,
                main_event_id: Alpine.store('cart').mainEvent.id
            });
        },

        toggleImage({ detail: { image, action } }) {
            this.refreshVirtualScroll(image);

            if(action === 'saved') {
                this.imagesCount = this.imagesCount + (image.saved ? 1 : -1);
            }

            if(action === 'favorite' || (!image.saved && image.old_favorite)) {
                this.favoriteCount = this.favoriteCount + (image.favorite ? 1 : -1);
            }
        }
    };
};
